<div class="logo">
  <app-icon iconStyle="reveleer" iconType="reveleer" iconName="logo-icon"></app-icon>
</div>
<div class="logo logo--text">
  <app-icon iconStyle="reveleer" iconType="reveleer" iconName="logo-text--white"></app-icon>
</div>